import React, { useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import CSVImport from '../components/CSVImport';
import ImportHistory from '../components/ImportHistory';
import ImportJobStatus from '../components/ImportJobStatus';
import { Heading } from '../components/ui/heading';

const DataImport: React.FC = () => {
  const { user } = useAuth();
  const [selectedTab, setSelectedTab] = useState<'import' | 'history'>('import');
  const [selectedJobId, setSelectedJobId] = useState<string | null>(null);

  const handleImportComplete = () => {
    // Refresh history or show success message
    setSelectedTab('history');
  };

  const handleViewDetails = (jobId: string) => {
    setSelectedJobId(jobId);
  };

  const handleBackToList = () => {
    setSelectedJobId(null);
  };

  if (!user?.organization_id) {
    return (
      <div className="p-4">
        <p className="text-red-600">No organization selected. Please select an organization first.</p>
      </div>
    );
  }

  return (
    <div className="container mx-auto p-4">
      <Heading level={1} weight="bold" className="mb-6">Data Import</Heading>

      {selectedJobId ? (
        <div>
          <button 
            onClick={handleBackToList}
            className="mb-4 text-blue-600 hover:underline flex items-center"
          >
            <svg className="w-4 h-4 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 19l-7-7m0 0l7-7m-7 7h18" />
            </svg>
            Back to Import History
          </button>
          <ImportJobStatus importJobId={selectedJobId} />
        </div>
      ) : (
        <div>
          <div className="border-b border-gray-200 mb-6">
            <nav className="-mb-px flex space-x-8">
              <button
                className={`py-2 px-1 ${
                  selectedTab === 'import'
                    ? 'border-b-2 border-blue-500 text-blue-600'
                    : 'border-b-2 border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                }`}
                onClick={() => setSelectedTab('import')}
              >
                Import Data
              </button>
              <button
                className={`py-2 px-1 ${
                  selectedTab === 'history'
                    ? 'border-b-2 border-blue-500 text-blue-600'
                    : 'border-b-2 border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                }`}
                onClick={() => setSelectedTab('history')}
              >
                Import History
              </button>
            </nav>
          </div>
          
          {selectedTab === 'import' ? (
            <CSVImport 
              orgId={user.organization_id} 
              onImportComplete={handleImportComplete}
            />
          ) : (
            <ImportHistory 
              orgId={user.organization_id}
              onViewDetails={handleViewDetails}
            />
          )}
        </div>
      )}
    </div>
  );
};

export default DataImport;